import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Environment, setAuthGateUrl, setClientId, setCookieDomain, setEnv, setResetPasswordRedirect } from '../utils/config';
import { getCookie } from '../utils/cookieManager';
import { refreshToken } from './refreshToken';
import { checkRefresh, setTokens } from './setTokens';
import { initBroadCastListener } from '../utils/broadcastListeners';
import { sendNewRelicEvent } from '../utils/newRelicEvents';

//@ts-ignore
import { version } from '../../package.json';
export { init };
var defaultParams = {
  env: Environment.prod,
  clientId: 'CHGG',
  refreshOnStart: true
};
function init(_x) {
  return _init.apply(this, arguments);
}
function _init() {
  _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    var _defaultParams$params, env, domainUrl, cookieDomain, clientId, refreshOnStart, resetPasswordSuccessRedirect, authGateUrl, cDomain, idToken, accessToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          sendNewRelicEvent({
            EventName: 'init',
            version: version
          });
          if (typeof window !== 'undefined') {
            window.addEventListener('online', function () {
              return checkRefresh();
            });
          }
          _defaultParams$params = _objectSpread(_objectSpread({}, defaultParams), params), env = _defaultParams$params.env, domainUrl = _defaultParams$params.domainUrl, cookieDomain = _defaultParams$params.cookieDomain, clientId = _defaultParams$params.clientId, refreshOnStart = _defaultParams$params.refreshOnStart, resetPasswordSuccessRedirect = _defaultParams$params.resetPasswordSuccessRedirect, authGateUrl = _defaultParams$params.authGateUrl;
          setEnv(env);
          if (resetPasswordSuccessRedirect) {
            setResetPasswordRedirect(resetPasswordSuccessRedirect);
          }
          cDomain = cookieDomain || domainUrl;
          /* istanbul ignore else */
          if (env == Environment.test && domainUrl) {
            console.warn('`domainUrl` parameter is deprecated - please use `cookieDomain` instead');
          }
          if (cDomain) {
            setCookieDomain(cDomain);
          }
          if (authGateUrl) {
            setAuthGateUrl(authGateUrl);
          }
          setClientId(clientId);
          idToken = getCookie('id_token');
          accessToken = getCookie('access_token');
          initBroadCastListener();
          if (!(idToken && accessToken)) {
            _context.next = 17;
            break;
          }
          _context.next = 16;
          return setTokens({
            idToken: idToken,
            accessToken: accessToken,
            callInitSession: false
          });
        case 16:
          return _context.abrupt("return");
        case 17:
          if (!(idToken && refreshOnStart)) {
            _context.next = 20;
            break;
          }
          _context.next = 20;
          return refreshToken();
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _init.apply(this, arguments);
}